export const TouchHereArrowSvg = () => {
  return (
    <svg width="8" height="25" viewBox="0 0 8 25" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M0 17.7333L3.24 21.0233V0H4.77V21.0233L8.01 17.7333V20.1017L4.01 24.255L0.01 20.1017V17.7333H0Z"
        fill="white"
      />
    </svg>
  )
}
